import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {SharedModule} from 'app/shared/shared.module';
import { MobileLanguagesComponent } from './mobile-languages.component';

@NgModule({
    declarations: [
        MobileLanguagesComponent
    ],
    imports: [
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        SharedModule
    ],
    exports: [
        MobileLanguagesComponent
    ]
})
export class MobileLanguagesModule {
}
